module.exports = __webpack_public_path__ + "media/A_2.93189ef1.mp3";